/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';

import {AdnApiClientService} from '../common/controller/adn-api-client.service';
import {
  SignalAdminResourceApiBase,
  SignalAdminResourceModel,
  SignalAdminResourcePage
} from '../common/controller/signal-admin-resource-api';

export interface TriggerModel extends SignalAdminResourceModel {
  [key: string]: any;
}

@Injectable({providedIn: 'root'})
export class TriggerApiService extends SignalAdminResourceApiBase<TriggerModel> {
  constructor(client: AdnApiClientService) {
    super(client, 'triggers');
  }

  listForSegment(segmentId: string): Observable<SignalAdminResourcePage<TriggerModel>> {
    return this.client.request<SignalAdminResourcePage<TriggerModel>>({
      method: 'GET',
      url: this.resourceUri('triggers'),
      params: {
        includeHidden: false,
        includeActive: true,
        includeInactive: false,
        orderBy: 'name',
        orderByDirection: 'ASCENDING',
        pageSize: 100,
        page: 1,
        concise: true,
        segment: segmentId
      }
    });
  }
}
